export * as checkboxStyleConfigs from './style-configs';
export type { CheckboxProps } from './types';
export { Checkbox } from './checkbox';
